<template>
  <div>
    <div v-if="isClues" class="container">
      <div class="nav">
        <div class="nav_hader">
          <ul class="nav_left">
            <li class="bottom hove"  @click="onMine()" :class="{ active: active === 'mine' }">
              我的线索
            </li>
            <li class="bottom hove" @click="onAll()" :class="{ active: active === 'all' }">
              全部线索
            </li>
            <li class="bottom hove" @click="onSub()" :class="{ active: active === 'sub' }">
              我下属的线索
            </li>
          </ul>
          <ul class="nav_right">
            <li>
              <exportExcel :isAllSelect="isAllSelect"></exportExcel>
            </li>
            <li>
              <el-button type="primary" class="btn-big" icon="el-icon-plus" @click="onAdd">
                新增线索
              </el-button>
              <el-button type="primary" class="btn-big" icon="el-icon-s-promotion" @click="onSubmit = true">
                导入线索
              </el-button>
              <el-button type="primary" style="margin-right:0px" class="btn-big" icon="el-icon-upload" @click="onDown">
                下载模板
              </el-button>
            </li>
          </ul>
        </div>
      </div>
      <div style="width: 100%">
        <div class="nav_body">
          <div class="grid">
            <div class="cell">
              <div class="grid-content bg-purple">跟进状态：</div>
              <div class="selection">
                <el-select v-model="is_record" @change="toggleRecord" placeholder="请选择">
                  <el-option v-for="item in RecordOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="cell">
              <div class="grid-content bg-purple bg-purple-lang">跟进时间：</div>
              <div class="">
                <el-date-picker v-model="recordTime" type="datetimerange" :picker-options="pickerOptions"
                  @change="onRecordTime()" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  align="right"></el-date-picker>
              </div>
            </div>
            <div class="cell">
              <div class="grid-content bg-purple">创建时间：</div>
              <div class="">
                <el-date-picker v-model="createTime" type="datetimerange" @change="onCreateTime()"
                  :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  align="right"></el-date-picker>
              </div>
            </div>
            <div class="cell">
              <div class="grid-content bg-purple">线索来源：</div>
              <div class="selection">
                <el-select v-model="source_id" @change="changeSource" placeholder="请选择">
                  <el-option v-for="item in source" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="cell">
              <div class="grid-content bg-purple">选择下属：</div>
              <div class="selection" @click="handleSub">
                <el-input placeholder="请选择下属" v-model="subName" suffix-icon="el-icon-arrow-down" @click.stop>
                </el-input>
              </div>
            </div>
            <div class="cell">
              <div class="grid-content bg-purple">地区搜索：</div>
              <div class="selection">
                <el-input v-model="address" placeholder="请输入地区搜索" clearable @change="chaxun"> </el-input>
              </div>
            </div>
            <div class="cell">
              <div class="grid-content bg-purple">自定义字段：</div>
              <div class="selection">
                <el-input v-model="selfC" placeholder="请输入自定义字段搜索" clearable @change="chaxun"> </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body">
        <div>
          <div class="input">
            <div class="mind">
              <el-button type="danger" v-if="this.$store.state.user.userInfo.leads_delete === 1" :disabled="lockDel"
                @click="del">
                <i class="iconfont iconshanchu"></i>
                删除
              </el-button>
              <el-button type="primary" class="btn-big" :disabled="lockOther" @click="transToOther">
                <i class="iconfont iconzhuanranggai"></i>
                转给他人
              </el-button>
              <el-button class="btn-big" type="primary" :disabled="lockPool" @click="transPool">
                <i class="iconfont iconzhuanyixiansuochi"></i>
                投入线索池
              </el-button>
            </div>
            <div class="abu">
              <el-input v-model="input" placeholder="请输入姓名或联系电话" clearable @change="chaxun">
                <el-button slot="append" style="width: 8.0rem;color: #fff" type="primary" @click="chaxun">查询</el-button>
              </el-input>
            </div>
          </div>
        </div>
        <div class="table">
          <el-table id="educe-table" ref="multipleTable" :data="tableData"  stripe v-loading="tableLoading"
            @selection-change="handleSelectionChange"   > <!-- @row-click="handleRead"--->
            <el-table-column type="selection" min-width="5.5rem;" :key="Math.random()"></el-table-column>
            <!-- <template v-for="item of fields" v-if="item.prop === 'gender'"> -->
            <div v-for="(item, index) in fields" :key="index">
              <el-table-column v-if="item.prop == 'photo'" :prop="item.field" :label="item.title">
                <template slot-scope="scope">
                  <div v-for="i in scope.row.photo" :key="i">
                    <img class="pic" :src="i">
                  </div>
                </template>
              </el-table-column>
              <!-- 跟进内容模块 -->
              <el-table-column   v-else-if="item.field === 'recordContent'" :key="item.field" :prop="item.field"
                :label="item.title" resizable>
                <template slot-scope="scope">
                  <el-popover  trigger="click" placement="top">
                    <record v-if="scope.row.isShow" ref="record" isSimple :data="scope.row" types="leads"></record>
                    <div slot="reference" @mouseenter="handleMouseenter(scope.row)">
                      {{ scope.row.recordContent }}
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column v-else show-overflow-tooltip :prop="item.field" :label="item.title">
              </el-table-column>
            </div>
            <el-table-column class-name="operation" fixed="right"  width="145">
              <template slot="header">
                <span>操作</span>
                <i class="more iconfont icongengduo" @click="onMore"></i>
              </template>
              <template slot-scope="scope">
                <el-button @click="handleRead(scope.row)" type="text">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
          :page-sizes="[10, 20, 50, 100]"
          :auto-scroll="false"
          @pagination="getData" />
      </div>
      <el-tooltip placement="top" content="返回顶部">
        <back-to-top :visibility-height="300" :back-position="0" transition-name="fade" />
      </el-tooltip>
      <el-dialog title="导入线索" :visible.sync="onSubmit" width="700px">
        <el-form class="el-form-uoload">
          <el-upload :action="`${baseURL}/home/uploads/uploads`" :on-success="chenggong" :before-remove="beforeRemove"
            multiple drag :limit="1" :on-exceed="handleExceed" :file-list="fileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div slot="tip" class="el-upload__tip">
              只能上传 .xls 文件，且不超过 500kb
            </div>
          </el-upload>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="; (onSubmit = false), rel()">取 消</el-button>
          <el-button type="primary" @click="; (onSubmit = false), numoo()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="错误信息" :visible.sync="onSubmitss" width="700px">
        <!--<div class="abude">
          <div v-for="item in value4" :key="item">{{ item }}</div>
        </div>--->
        <!--<div class="abude">
        <el-table id="educe-table" :cell-style="columnStyle" tooltip-effect="dark" style="width: 100%" :data="value4"
          border>
        </el-table>
      </div>--->
        <div class="abude">
          <el-table tooltip-effect="dark" style="width: 95%;margin:0 auto ;" :data="value4" border>
            <el-table-column prop="name" label="线索名">
            </el-table-column>
            <el-table-column prop="message" label="错误信息"></el-table-column>
            <el-table-column proqp="mobiles" label="手机号"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="; (onSubmitss = false), rel()">取 消</el-button>
          <el-button type="primary" @click="; (onSubmitss = false), rel()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog class="record-add" title="新增线索" width="1300px" :modal-append-to-body="false" :visible.sync="showAdd"
        destroy-on-close @close="closeAdd">
        <el-form :inline="true" ref="ruleForm" label-width="14.0rem" label-position="right">
          <template v-for="item of forms">
            <el-form-item v-if="item.type === 'el-input'" :label="item.label" :required="item.required" :key="item.id">
              <template v-if="item.prop === 'remark_mobiles'">
                <div  class="phone" v-for="(i, index) of item.default_val" :key="index">
                  <el-input   v-model="item.default_val[index].tel" :placeholder="item.placeholder" :style="item.style"
                    @blur="onCheckTel(item.default_val[index])" :clearable="item.clearable"></el-input>
                    <div class="btn-box">
                    <el-button :disabled="nolength" :style="{ display: index == 0 ? 'true' : '' }" class="add-btn" icon="el-icon-minus"
                    @click="delPhone(item.default_val, index)"></el-button>
                    <span></span>
                    <!-- v-if="index == item.default_val.length - 1" -->
                  <el-button class="add-btn" icon="el-icon-plus"
                    @click="addPhone(item.default_val)"></el-button>
                  </div>
                  <p v-if="item.default_val[index].code == 99" style="color: #f56c6c; margin-left: 2.0rem">
                    <i class="el-icon-error" style="margin-right: .4rem"></i>
                    <span>{{ item.default_val[index].errorMsg }}</span>
                  </p>
                  <p v-if="item.default_val[index].code == 1" style="color: #67c23a; margin-left: 2.0rem">
                    <i class="el-icon-success" style="margin-right: .4rem"></i>
                    <span>{{ item.default_val[index].errorMsg }}</span>
                  </p>
                </div>
              </template>
              <template v-else-if="item.prop === 'detail_address'">
                <el-input v-model="item.default_val" :placeholder="item.placeholder" :style="item.style"
                  :clearable="item.clearable">
                  <el-button slot="append" icon="el-icon-map-location" @click="toMap()"></el-button>
                </el-input>
              </template>
              <template v-else>
                <el-input v-model="item.default_val" :placeholder="item.placeholder" :style="item.style"
                  :clearable="item.clearable"></el-input>
              </template>
            </el-form-item>
            <el-form-item v-if="item.type === 'el-selecte'" :label="item.label" :required="item.required" :key="item.id">
              <el-select v-model="item.default_val" :placeholder="item.placeholder" :clearable="item.clearable">
                <el-option v-for="i in item.options" :key="i.id" :label="i.text" :value="i.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="item.type === 'el-date-picker'" :label="item.label" :required="item.required"
              :key="item.id">
              <el-date-picker v-model="item.default_val" type="date" :placeholder="item.placeholder"
                :clearable="item.clearable" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </template>
        </el-form>
        <el-divider></el-divider>
        <form-create v-model="yulanform" :rule="formrule" :option="option" @on-submit="onSubmit1"
          style="width: 100%;margin-top: 4.0rem;"></form-create>
        <div slot="footer" class="dialog-footer"  style="margin-top:-20px">
          <el-button type="primary" :loading="lockSave" @click="formSubmit">保存</el-button>
          <el-button type="primary" class="btn-big" :loading="lockAdd" @click="addContact">添加联系人</el-button>
        </div>
      </el-dialog>
      <contact ref="ContactAdd" type="leads" :id="leads_id"></contact>
      <mail-list ref="drawer" :module="module" :selectionDepartment="selectionDepartment"
        @handleSelect="handleSelect"></mail-list>
      <set-table ref="setting" types="leads" :selfState='selfState'></set-table>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import contact from '@/components/Contact/add'
import mailList from '@/components/drawer/mailList'
import Pagination from '@/components/Pagination'
import setTable from '@/components/setTable'
import qs from 'qs'
import record from "@/components/Record";
import { delLeads, addLeads } from '@/api/clues'
import { putIntoSeas, transferUsers, getSourceList, checkPhone } from '@/api/common'
import { getFieldConfigs, getFieldControl } from '@/api/user'
import exportExcel from '@/components/exportExcel'
export default {
  name: 'clues',
  inject: ['reload'],
  components: {
    mailList,
    Pagination,
    setTable,
    contact,
    exportExcel,
    record
  },
  data() {
    return {

      //是否全选
      isAllSelect:true,
      //当前页面state
      selfState: 'leads',
      selectionDepartment: true,
      showAdd: false,
      forms: [],
      btn: '',
      module: '',
      active: 'mine',
      activeR: 'all',
      actives: 0,
      source: [],
      source_id: '',
      is_record: 0,
      total: 0,
      listQuery: {
        page: 1,
        limit: 20
      },
      boxShow: false,
      onSubmit: false,

      pickerOptions: {
        shortcuts: [
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1 - 60 * 60 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      recordTime: '',
      value: '',
      tableData: [],
      input: '',
      createTime: '',
      if_leader: 0,
      start_createtime: '',
      end_createtime: '',
      start_followtime: '',
      end_followtime: '',
      multipleSelection: [],
      fileList: [],
      baseURL: this.axios.defaults.baseURL,
      page: '1',
      loading: false,
      form: {
        enterprisePhoto: ''
      },
      value4: [],
      onSubmitss: false,
      fields: [],
      leads_id: 0,
      lockSave: false,
      lockAdd: false,
      lockDel: false,
      lockOther: false,
      lockPool: false,
      subName: '',
      subUserid: '',
      RecordOptions: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '已跟进'
        },
        {
          value: 2,
          label: '未跟进'
        }
      ],
      address: '',
      mLong: '',
      mLat: '',
      yulanform: '',
      formrule: [],
      option: {
        submitBtn: {
          show: false
        }
      },
      fie: [],
      custom_field: {},
      selfC: "",
      tableLoading: true
    }
  },
  computed: {
    isClues() {
      return this.$route.name === 'clues'
    },
    nolength() {
      let i
      this.forms.map((item, index) => {
        if (item.label === '联系电话') {
          i = index
        }
      })
      let a
      if(this.forms[i].default_val.length==1){
         a = true
      }
      return a;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'cluesDetail') {
      // 详情页路由
      to.meta.isBack = true
    } else if (from.name === 'map') {
      to.meta.isBack = false
      next(vm => {
        vm.forms.forEach((item, index) => {
          if (item.prop === 'detail_address') {
            vm.forms[index].default_val = vm.$route.params.address
          }
        })
        vm.mLong = vm.$route.params.long
        vm.mLat = vm.$route.params.lat
      })
    } else {
      to.meta.isBack = false
      next((vm) => {
        vm.is_record=''
        vm.source_id=''
        vm.recordTime=''
        vm.createTime=''
        vm.subName=''
        vm.address=''
        vm.selfC =''
        vm.input=''
        });



    }
    next()
  },
  activated() {
    if (!this.$route.meta.isBack) {
      if (this.total % this.listQuery.limit == 1 || this.$refs.multipleTable.store.states.isAllSelected) {
        this.listQuery.page = this.listQuery.page - 1
      }
      //当选择了下属
      if(this.subUserid != '' ){
        this.if_leader = '0'
      }
      this.getData() // 不是详情页面(detail.vue)进入，更新初始化列表数据
    } else {
      // 这是详情页返回，可任意写自己需要处理的方法
      this.$route.meta.isBack = false // 重置详情页标识isBack
    }
  },
  created() {
    console.log(this.forms)
    this.getFields()
  },
  async mounted() {
    await this.getSource()
    this.onMine()
    this.getField()
  },
  methods: {
    handleMouseenter(row) {
      row.isShow = true;
    },
    // async getFields() {
    //   const res = await getSelfAPI({
    //     account_id: this.$store.state.user.token.account_id,
    //     user_id: this.$store.state.user.token.userid,
    //     state: this.selfState,
    //   });
    //   if (res.code == 1) {
    //     this.fields = res.data.merge_field
    //   } else {
    //     this.fields = []
    //   }
    // },
    handleClear() {
      this.subName = ''
      this.subUserid = ''
      this.listQuery.limit = 20
      this.listQuery.page = 1
      this.getData()
    },
    handleSub() {
      this.listQuery.page=1

      this.module = 'getUnderUser'
      this.selectionDepartment = false
      this.$refs.drawer.open()
    },
    async onCheckTel(obj) {

      try {
        const res = await checkPhone({
          account_id: this.$store.state.user.token.account_id,
          remark_mobiles: obj.tel
        })
        obj.errorMsg = res.msg
        obj.code = res.code
      } catch (error) {
        console.log(error)
      }
    },
    addPhone(item) {
      item.push({
        tel: '',
        errorMsg: '',
        code: 0
      })
    },
    delPhone(arr, index) {
      if (arr.length === 1) {
        arr[0] = {
          tel: '',
          errorMsg: '',
          code: 0
        }
        arr.push()
        return
      }
      arr.splice(index, 1)
    },
    async getFields() {
      let fields = await getFieldControl({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        types: 'leads'
      })
      this.tableLoading = false;
      this.fields = fields.data
    },
    async getConfigs() {
      const res = await getFieldConfigs({
        account_id: this.$store.state.user.token.account_id,
        types: 'leads'
      })
      const data = res.data
      data.filter(item => {
        if (item.prop === 'remark_mobiles') {
          item.default_val = [
            {
              tel: '',
              errorMsg: '',
              code: 0
            }
          ]
        }
      })
      this.forms = res.data
      console.log(res.data,'data')
    },
    async getSource() {
      const source = await getSourceList({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid
      })
      source.data.unshift({
        id: 0,
        name: '全部'
      })
      this.source = source.data.map(i => {
        return {
          value: i.id,
          label: i.name
        }
      })
    },
    async getData() {
      // if((this.input||((this.start_createtime||this.end_createtime)||(this.start_followtime||this.end_followtime)))||((this.source_id||this.is_record)||(this.address||this.selfC))){
      //   this.listQuery.page=1
      // }
      const userid = this.subUserid ? this.subUserid : this.$store.state.user.token.userid
      const tableData = await this.axios.post(
        '/crm/Leads/leadsList',
        qs.stringify({
          account_id: this.$store.state.user.token.account_id,
          userid,

          if_leader: this.if_leader,
          start_createtime: this.start_createtime,
          end_createtime: this.end_createtime,
          start_followtime: this.start_followtime,
          end_followtime: this.end_followtime,
          name: this.input,
          page: this.listQuery.page,
          number_page: this.listQuery.limit,
          source_id: this.source_id,
          is_record: this.is_record,
          //number_page: d?.limit ?? 20,
          detail_address: this.address,
          self_content: this.selfC,

        })
      )
      this.total = tableData.count
      // this.tableData = tableData.data
      this.tableData = tableData.data.map((i) => {
        i.isShow = false;
        return i;
      });
    },
    async onSave() {
      let data = {}
      let telArray = []
      let arr = JSON.parse(JSON.stringify(this.forms))
      for (const item of arr) {
        if(item.prop === 'up_date'){
          item.default_val=item.default_val.substring(0,10)
        }
        if (item.required) {
          if (item.default_val == '') {
            this.$message.error(`${item.label}不能为空！`)
            return
          }
        }
        if (item.prop === 'remark_mobiles') {
          telArray = item.default_val
          item.default_val = item.default_val.map(m => m.tel)
        }

        Reflect.set(data, item.prop, item.default_val)
      }
      let selfSub = {}
      for (let i in this.custom_field) {
        this.fie.push(i)
      }
      for (let i = 0; i < this.fie.length; i++) {
        for (let j = 0; j < this.formrule.length; j++) {
          if (this.formrule[j].field == this.fie[i]) {
            this.$set(selfSub, this.fie[i], this.formrule[j])
          }
        }
      }
      Reflect.set(data, 'account_id', this.$store.state.user.token.account_id)
      Reflect.set(data, 'userid', this.$store.state.user.token.userid)
      Reflect.set(data, 'long', this.mLong)
      Reflect.set(data, 'lat', this.mLat)
      Reflect.set(data, 'detail_address_name', this.$route.params.address)
      Reflect.set(data, 'self_content', JSON.stringify(selfSub))
      if (this.btn === 'add') {
        this.lockAdd = true
      } else {
        this.lockSave = true
      }
      const res = await addLeads(data)
      if (res.code == 1) {
        if (this.btn === 'add') {
          this.leads_id = res.data.leads_id
          this.$refs.ContactAdd.open()
        }
        this.closeAdd()
        this.total = 0
        this.tableData = []
        this.getData()
      }
      this.lockSave = false
      this.lockAdd = false
      for (const item of this.forms) {
        // 此处是为了把手机数组重新改为前端可用的数组，方便手机号验证错误信息的展示
        if (item.prop === 'remark_mobiles') {
          item.default_val = telArray
        }
      }
    },
    formSubmit() {
      this.btn = 'submit'
      this.onSave()
    },
    onAdd() {
      this.showAdd = true
      this.getConfigs();
      this.getField();
    },
    closeAdd() {
      this.showAdd = false
    },
    addContact() {
      this.btn = 'add'
      this.onSave()
    },
    handleRead(row) {
      this.$store.commit('app/SET_CLUES', row)
      if (this.subName != '') {
        this.if_leader = 1
      }
      this.$router.push({
        name: 'cluesDetail',
        params: {
          id: row.id
        },
        query: {
          page: row.currentPage,
          number_page: row.number_page,
          ifLeader: this.if_leader
        }
      })
    },
    del() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: '请选择线索!'
        })
        return
      }
      this.$confirm('您确定要删除当前选中线索吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let ids = []
          for (const i of this.multipleSelection) {
            ids.push(i.id)
          }
          this.lockDel = true

          let res = await delLeads({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            ids: ids.join(',')
          })
          if (res.code === 1) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            if (this.total % this.listQuery.limit == 1 || this.$refs.multipleTable.store.states.isAllSelected) {
              this.listQuery.page = this.listQuery.page - 1
            }
            this.getData()
            //this.reload()
          }
          this.lockDel = false
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.is_record === 1) {
        return 'success-row'
      }
      if (rowIndex % 2 === 0) {
        return 'warning-row'
      }
      return ''
    },
    toggleRecord() {
      this.listQuery.page=1
      this.getData()
    },
    changeSource() {
      this.listQuery.page=1
      this.getData()
    },
    onMore() {
      this.$refs.setting.open()
    },
    transToOther() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: '请选择线索!'
        })
        return
      }
      this.module = 'getAddressBook'
      this.selectionDepartment = true
      this.$refs.drawer.open()
    },
    transPool() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: '请选择线索!'
        })
        return
      }

      this.$confirm('您确定要投入线索池吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let ids = []
          for (const i of this.multipleSelection) {
            ids.push(i.id)
          }
          this.lockPool = true

          let res = await putIntoSeas({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            type: 1,
            ids: ids.join(',')
          })

          if (res.code === 1) {
            this.$message({
              type: 'success',
              message: '投入成功!'
            })
            if (this.total % this.listQuery.limit == 1 || this.$refs.multipleTable.store.states.isAllSelected) {
              this.listQuery.page = this.listQuery.page - 1
            }
            //this.reload()
            this.getData()
          }
          this.lockPool = false
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消投入'
          })
        })
    },
    handleSelect(person) {
      if (person.name == undefined) {
        this.$message({
          type: "info",
          message: "请选择名称",
        });
        return
      }
      // 转移给他人
      if (this.module === 'getAddressBook') {
        this.$confirm(`您确定转让此线索吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async () => {
            let ids = []
            for (const i of this.multipleSelection) {
              ids.push(i.id)
            }
            this.lockOther = true

            let res = await transferUsers({
              account_id: this.$store.state.user.token.account_id,
              userid: this.$store.state.user.token.userid,
              type: 1,
              ids: ids.join(','),
              owner:person.userid,
            })
            if (res.code === 1) {
              this.$message({
                type: 'success',
                message: '转让成功!'
              })
              if (this.total % this.listQuery.limit == 1 || this.$refs.multipleTable.store.states.isAllSelected) {
                this.listQuery.page = this.listQuery.page - 1
              }
              //this.reload()
              this.getData()
            }
            this.lockOther = false
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消转让'
            })
          })
      }
      // 选择下属
      if (this.module === 'getUnderUser') {
        this.if_leader = '0'
        this.subName = person.name
        this.subUserid = person.userid
        this.getData()
      }


    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 名称查询
    chaxun() {
      this.listQuery.page=1

      this.getData()
    },
    // 创建时间
    onCreateTime() {
      // console.log(Array.isArray(this.createTime))
      if (Array.isArray(this.createTime)) {
        let a = this.createTime[0].valueOf()
        let b = this.createTime[1].valueOf()
        this.start_createtime = parseInt(a / 1000)
        this.end_createtime = parseInt(b / 1000)

      } else {
        this.start_createtime = ''
        this.end_createtime = ''

      }
      this.listQuery.page=1
      this.getData()
    },
    // 实际跟进时间
    onRecordTime() {
      if (Array.isArray(this.recordTime)) {
        let a = this.recordTime[0].valueOf() / 1000
        let b = this.recordTime[1].valueOf() / 1000
        this.start_followtime = parseInt(a)
        this.end_followtime = parseInt(b)

      } else {
        this.start_followtime = ''
        this.end_followtime = ''

      }
      this.listQuery.page=1
      this.getData()
    },
    pull() {
      this.toggle = !this.toggle
    },
    onAll() {
      this.subName = ''
      this.subUserid = ''
      this.active = 'all'
      this.if_leader = '3'
      this.input = ''
      this.handleClear()
    },
    onMine() {
      this.subName = ''
      this.subUserid = ''
      this.active = 'mine'
      this.if_leader = '0'
      this.input = ''
      this.handleClear()
    },
    onSub() {
      this.subName = ''
      this.subUserid = ''
      this.active = 'sub'
      this.if_leader = '1'
      this.input = ''
      this.handleClear()
    },
    numoo() {
      this.loading = true
      this.daoru()
    },
    rel() {
      this.reload()
    },
    daoru() {
      this.axios
        .post(
          '/crm/Leads/importDataLeads',
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            file_path: this.form.enterprisePhoto,
            page: this.page
          }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(res => {
          if (res.code == 1) {
            this.page = this.page * 1 + 1
            this.daoru()
          } else if (res.code == 3) {
            this.loading = false
            this.onSubmitss = true
            this.value4 = res.data
            this.onAll()
            return
          } else if (res.code == 2) {
            this.loading = false
            this.onAll()
            this.$message({
              message: res.msg,
              type: 'success'
            })

          }
        })
        .catch(function (err) {
          console.log(err)
        })
      this.fileList = []
    },
    chenggong(response, file) {
      if (response.code == 1) {
        this.$message({
          message: response.msg,
          type: 'success'
        })
        this.form.enterprisePhoto = file.response.data;
      } else {
        this.$message({
          message: response.msg,
          type: 'error'
        })
        this.fileList = []
        this.form.enterprisePhoto = '';
      }
    },
    handleExceed() {
      this.$message.warning(
        `当前限制选择 1 个文件，如需更换请先删除`
      )
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`).then(() => {
        this.fileList = []
        this.form.enterprisePhoto = ''
      })
    },
    onDown() {
      window.open('https://api.weijub.com/tmp/线索列表.xls')
    },
    toMap() {
      this.$router.push({ name: 'map' })
    },
    async getField() {
      const res = await this.axios({
        url: '/crm/ApplyExpense/get_custom_filed',
        method: 'POST',
        data: {
          account_id: this.$store.state.user.token.account_id,
          state: 'leads'
        }
      })
      if (res.code == 1) {
        this.custom_field = res.data.custom_field
        let arr = []
        this.formrule = []
        for (let i in this.custom_field) {
          arr.push(this.custom_field[i])
        }
        arr.forEach(item => {
          if (!item.if_show) {
            item.display = item.if_show
          }
          this.formrule = arr;
        })
      }
    },
    onSubmit1(formData) {
      alert(JSON.stringify(formData))
    },
    columnStyle({ columnIndex }) {
      if (columnIndex == 0) {
        return 'color:	red;'
      }
    },

  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/index-common.scss';

::v-deep .cooperation input {
  cursor: pointer;
}
.btn-box{
  border-radius: 20px;
  width: 100px;
  border: 0px ;
  height: 100%;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;

}
.btn-box>span{
    height: 25px;
    background: #e6e6e6;
    width: 1px;
}
.add-btn {
  margin-left: 0px;
  margin-right:0px;
  height: 100%;
  width: 50% !important;
  border: none;
  background: none;
}

.phone {
  margin-top: 12px;
  display: flex;
}

.phone:nth-child(1) {
  margin-top: 6px;
}


.el-form-item{
  width:50%;
}
::v-deep .el-form--inline .el-form-item{
  margin-right: 0px;
  margin-bottom: 30px;
}
.el-divider{
  height: 5px;
  margin: 10px 0;
}
::v-deep .form-create .el-form-item__label {
  width:14rem !important;}
::v-deep .form-create .el-input,
.el-dialog .el-select,
 .el-dialog .el-input{
  width:470px !important;
}
.el-input__inner{
  border-color: #e6e6e6;
  border-radius: 8px;

}
.phone .el-input__inner,
.phone .el-input{
  width:330px !important;
  margin-right: 20px;

}
::v-deep .el-col-24 {
    width: 50%;
}

</style>
